// import {httpService} from './http.service';
import { api } from './api';
import { loggerService } from './logger.service';
import { uiService } from './ui.service';
import { jqService } from './jq.service';
import { modalService } from './modal/modal.service';

export const services = angular
  .module('services', [])
  .factory('API', api)
  // .factory('httpService', httpService)
  .factory('loggerService', loggerService)
  .factory('modalService', modalService)
  .factory('uiService', uiService)
  .factory('jqService', jqService);



/** WEBPACK FOOTER **
 ** ./src/app/shared/services/services.js
 **/